<template>
  <modal name="user-profile-modal"
    :classes="['v--modal', 'user-profile-modal']"
    :pivot-y="0.16"
    :pivot-x="0.92"
    :width="260"
    :height="320"
    >

    <div class="text-center" style="padding-top:20px" v-if="user.loggedIn">
      <div style="padding-bottom:40px">
        <font-awesome-icon color="grey" size="2x" icon="user-circle" />
      </div>
      <div>
        <p><b>{{ user.data.first_name }} {{ user.data.last_name }}</b></p>
      </div>
      <div style="padding-bottom:10px">
        <p>{{ user.data.email_address }}</p>
      </div>
      <div  style="padding-bottom:30px">
        <router-link to="/register" style="text-decoration:none">
          <v-btn rounded outlined width="220" class="text-capitalize">Manage your Account</v-btn>
        </router-link>
      </div>
      <div  style="padding-bottom:30px">
        <v-btn outlined width="160" class="text-capitalize" @click="signOut();$modal.hide('user-profile-modal');">Sign out</v-btn>
      </div>
    </div>
  </modal>
</template>
<script>
  import { mapGetters } from "vuex";
  //import { auth } from '@/fb'

  export default {
    name: 'UserProfileModal',
    computed: {
    // map `this.user` to `this.$store.getters.user`
      ...mapGetters({
        user: "user"
      })
    },
    methods: {
      signOut() {
        this.$store.dispatch("fetchUser", null);
        this.$router.push("/");
      }
    }
  }
</script>